import { useNavigate} from "react-router-dom";
import css from "./Connect.module.css"

const ConnectPage = () => {
    const navigate = useNavigate();

    const email = sessionStorage.getItem("email");
    const subid = sessionStorage.getItem("subid");
    if (!email || !subid) {
        navigate(-1);
        return;
    }

    document.title = "Подключение | SecureNet"


    const googlePlay = "https://play.google.com/store/apps/details?id=com.happproxy"
    const appStoreRU = "https://apps.apple.com/ru/app/happ-proxy-utility-plus/id6746188973"
    const appStoreGlobal = "https://apps.apple.com/us/app/happ-proxy-utility/id6504287215"
    const oficialSite = "https://happ.su"
    const importProxyProfile = () => {
        window.location.href = "happ://add/https://178.253.43.36:2096/sub/" + subid;
    }

    const particles = Array.from({length: 30}, (_, i) => (
        <div className={css.particle} key={i}
             style={{left: Math.random() * 100 + "%", animationDelay: Math.random() * 15 + "s", animationDuration: (Math.random() * 10 + 10) + "s"}}>
        </div>
    ));


    return (
        <>

            <div className={css.bgGrid}></div>
            <div className={`${css.bgGlow} ${css.bgGlow1}`}></div>
            <div className={`${css.bgGlow} ${css.bgGlow2}`}></div>
            <div className={css.particles} id="particles">
                {particles}
            </div>

            <div className={css.wrap}>

                <header className={css.top}>
                    <div className={css.logo}>
                        <div className={css.logoIco}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                                 stroke-linecap="round" stroke-linejoin="round">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                            </svg>
                        </div>
                        Secure Internet
                    </div>
                </header>

                <div className={css.title}>
                    <h1>Подключение подписки</h1>
                    <p>Установите приложение и добавьте подписку в один клик</p>
                </div>

                <section className={`${css.section} ${css.downloadsSection}`}>
                    <div className={css.sectionLabel}>Скачайте приложение</div>
                    <div className={css.downloads}>

                        <a href={appStoreRU} className={css.dlBtn} target="_blank" rel="noopener noreferrer">
                            <svg className={css.dlIco} viewBox="0 0 24 24" fill="currentColor">
                                <path
                                    d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                            </svg>
                            <div className={css.dlInfo}>
                                <span className={css.dlName}>Happ RU</span>
                                <span className={css.dlSub}>App Store</span>
                            </div>
                        </a>

                        <a href={appStoreGlobal} className={`${css.dlBtn} ${css.recommended}`} target="_blank" rel="noopener noreferrer">
                            <span className={css.recBadge}>рекомендуем</span>
                            <svg className={css.dlIco} viewBox="0 0 24 24" fill="currentColor">
                                <path
                                    d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                            </svg>
                            <div className={css.dlInfo}>
                                <span className={css.dlName}>Happ Global</span>
                                <span className={css.dlSub}>App Store</span>
                            </div>
                        </a>

                        <a href={googlePlay} className={css.dlBtn} target="_blank" rel="noopener noreferrer">
                            <svg className={css.dlIco} viewBox="0 0 24 24" fill="currentColor">
                                <path
                                    d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.27-.86-.31-.16-.69-.04-.86.27l-1.87 3.23c-1.38-.57-2.9-.89-4.44-.89-1.54 0-3.06.32-4.44.89L5.69 5.71c-.16-.31-.54-.43-.86-.27-.31.16-.43.55-.27.86L6.4 9.48C3.3 11.25 1.28 14.44 1 18h22c-.28-3.56-2.3-6.75-5.4-8.52zM7 15.25c-.69 0-1.25-.56-1.25-1.25S6.31 12.75 7 12.75s1.25.56 1.25 1.25S7.69 15.25 7 15.25zm10 0c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"/>
                            </svg>
                            <div className={css.dlInfo}>
                                <span className={css.dlName}>Happ</span>
                                <span className={css.dlSub}>Google Play</span>
                            </div>
                        </a>

                        <a href={oficialSite} className={css.dlBtn} target="_blank" rel="noopener noreferrer">
                            <svg className={css.dlIco} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                                 stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10"/>
                                <line x1="2" y1="12" x2="22" y2="12"/>
                                <path
                                    d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                            </svg>
                            <div className={css.dlInfo}>
                                <span className={css.dlName}>Официальный сайт</span>
                                <span className={css.dlSub}>happ.su</span>
                            </div>
                        </a>

                    </div>
                </section>

                <section className={`${css.section} ${css.stepsSection}`}>
                    <div className={css.sectionLabel}>Инструкция по установке</div>
                    <div className={css.steps}>

                        <div className={css.step}>
                            <div className={css.stepNum}>1</div>
                            <div className={css.stepText}>
                                Скачайте приложение на своё устройство
                                <span className={css.hint}>Выберите версию для iOS, Android или другого устройства выше. Этот клиент поможет вам подключиться к нашим серверам. <b>Важно</b>, мы не являемся представителем этого приложения!</span>
                            </div>
                        </div>

                        <div className={css.step}>
                            <div className={css.stepNum}>2</div>
                            <div className={css.stepText}>
                                Добавьте в приложение Happ VPN-подписку
                                <span className={css.hint}>Нажмите кнопку ниже — ссылка подставится автоматически</span>
                                <button className={css.stepAction} type="button" onClick={importProxyProfile}>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                                         stroke-linecap="round" stroke-linejoin="round">
                                        <line x1="12" y1="5" x2="12" y2="19"/>
                                        <line x1="5" y1="12" x2="19" y2="12"/>
                                    </svg>
                                    Добавить в приложение
                                </button>
                            </div>
                        </div>

                        <div className={css.step}>
                            <div className={css.stepNum}>3</div>
                            <div className={css.stepText}>
                                Нажмите кнопку подключения для начала пользования
                                <span className={css.hint}>Готово — ваше соединение защищено</span>
                            </div>
                        </div>

                    </div>
                </section>

                <div className={css.footerActions}>
                    <a href="#" className={`${css.btn} ${css.btnSupport}`}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                             stroke-linejoin="round">
                            <path d="M3 18v-6a9 9 0 0 1 18 0v6"/>
                            <path d="M21 19a2 2 0 0 1-2 2h-1v-6h3v4zM3 19a2 2 0 0 0 2 2h1v-6H3v4z"/>
                        </svg>
                        Техническая поддержка
                    </a>
                    <button className={`${css.btn} ${css.btnBack}`} onClick={() => navigate(-1)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                             stroke-linejoin="round">
                            <line x1="19" y1="12" x2="5" y2="12"/>
                            <polyline points="12 19 5 12 12 5"/>
                        </svg>
                        Вернуться назад
                    </button>
                </div>

            </div>
        </>

    );
}

export default ConnectPage;